// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1GDXk","rootSuccess":"CompleteLink_rootSuccess__1WJpd","rootFailure":"CompleteLink_rootFailure__SknWo","isDisabled":"CompleteLink_isDisabled__2Oq2T"};